import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import determineFooterContactLink from './determineFooterContactLink';

const Footer = (props) => {
	const { siteId, hideCart } = props;
	const navigate = useNavigate();

	const handleRouteToCart = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
		navigate('/cart');
	};

	return (
		<footer>
			<Stack
				alignItems='center'
				justifyContent='center'
				className='filter footerfilter'
				width='100%'
				spacing={3}
				sx={{ py: '40px', bgcolor: 'secondary.main' }}
			>
				{hideCart ? (
					<></>
				) : (
					<Button
						size='large'
						sx={{
							borderRadius: (theme) => theme.pixels.bRadius.main,
							textTransform: 'none',
							fontWeight: 600
						}}
						onClick={handleRouteToCart}
					>
						{`${'Go To Cart >'}`}
					</Button>
				)}
				{determineFooterContactLink(siteId)}
			</Stack>
		</footer>
	);
};

Footer.propTypes = {
	siteId: PropTypes.number
};

export default Footer;
